module.exports = __webpack_public_path__ + "img/payment-icons-06.3c3392ce.png";